import { render, staticRenderFns } from "./SidePane.vue?vue&type=template&id=54c7251e&"
import script from "./SidePane.vue?vue&type=script&lang=js&"
export * from "./SidePane.vue?vue&type=script&lang=js&"
import style0 from "./SidePane.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports